import type { ReactNode } from 'react';
import React from 'react';

import ErrorBoundary from '@rover/components/src/errorHandling/ErrorBoundary';
import { LAYOUT_TOP_FILTERS } from '@rover/constants/src/search/searchPage.constants';
import { Box } from '@rover/kibble/core';

import { StickyMap } from '..';

type Props = {
  children: ReactNode;
  onMarkerClick: (index: number) => void;
};

const SearchPageLayoutTopFilters = ({ children, onMarkerClick }: Props): JSX.Element => {
  return (
    <Box
      maxWidth={LAYOUT_TOP_FILTERS.AVAILABLE_WIDTH}
      px={['0x', LAYOUT_TOP_FILTERS.GUTTER]}
      sx={{ margin: '0 auto' }}
    >
      <Box display="flex">
        <ErrorBoundary location="SearchPageLayoutTopFilters-Children">{children}</ErrorBoundary>

        <ErrorBoundary location="SearchPageLayoutTopFilters-Map">
          <StickyMap onMarkerClick={onMarkerClick} />
        </ErrorBoundary>
      </Box>
    </Box>
  );
};

export default SearchPageLayoutTopFilters;
